import type { InspectorModeTags } from '@contentful/live-preview/dist/inspectorMode/types';
import type { LivePreviewProps } from '@contentful/live-preview';

// Shape consumers see via `$ContentfulLivePreview`, covering the static members
// used across the app (incl. `initialized`/`openEntryInEditor` on the CMS page).
// Both branches below provide this type so the SDK stays out of bundles that
// only need `getProps` when preview is disabled.
interface ContentfulLivePreviewApi {
  initialized: boolean;
  getProps: (props: LivePreviewProps) => InspectorModeTags;
  openEntryInEditor: (props: LivePreviewProps) => void;
}

export default defineNuxtPlugin({
  name: 'initContentfulLivePreview',
  async setup() {
    const {
      public: { isPreviewEnabled }
    } = useRuntimeConfig();

    if (!isPreviewEnabled) {
      const stub: ContentfulLivePreviewApi = {
        initialized: false,
        getProps: (_props: LivePreviewProps) => ({}) as InspectorModeTags,
        openEntryInEditor: () => {}
      };
      return {
        provide: {
          ContentfulLivePreview: stub
        }
      };
    }

    const { ContentfulLivePreview } = await import('@contentful/live-preview');

    ContentfulLivePreview.init({
      locale: 'de-DE',
      enableInspectorMode: true,
      enableLiveUpdates: true,
      debugMode: true,
      targetOrigin: 'https://app.contentful.com'
    });

    const api: ContentfulLivePreviewApi = ContentfulLivePreview;

    return {
      provide: {
        ContentfulLivePreview: api
      }
    };
  },
  enforce: 'pre'
});
